<div class="container-fluid p-h-0 p-v-20 h-100 bg" style="background-image: url('assets/images/others/login-bg.png')">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class=" d-md-block"></div>
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-7 col-lg-5 m-h-auto">
          <nz-card class="m-b-100 shadow-lg">
            <div class="d-flex align-items-center justify-content-between m-b-30">
              <img style="margin: auto" class="img-fluid" alt="" src="assets/images/logo/logohtnm.jpg">
            </div>
            <form nz-form [formGroup]="loginForm" nzLayout="vertical" class="login-form" (ngSubmit)="submitForm()">
              <extend-form [showError]="isSubmitted" [errorDefs]="FORM_VALIDATORS" [errors]="loginForm.errors"
                           [showError]="isSubmitted">

                <extend-form-item labelText="Tên đăng nhập" [errorDefs]="VALIDATORS.username"
                                  [errors]="f.username.errors" isRequired [showError]="isSubmitted">
                  <app-input-group-icon prefixIcon="user" prefixIconType="TABLER_ICON">
                    <input type="text" nz-input formControlName="username" placeholder="e.g. Tên đăng nhập">
                  </app-input-group-icon>
                </extend-form-item>
                <extend-form-item labelText="Mật khẩu" [errorDefs]="VALIDATORS.password" [errors]="f.password.errors"
                                  isRequired [showError]="isSubmitted">
                  <app-input-group-icon prefixIcon="key" prefixIconType="TABLER_ICON"
                                        [suffixIcon]="showPassword ? 'eye' : 'eye-off'"
                                        suffixIconType="TABLER_ICON"
                                        (suffixClickEvent)="showPassword = !showPassword">
                    <input [type]="showPassword ? 'text' : 'password'" nz-input formControlName="password" placeholder="e.g. ******">
                  </app-input-group-icon>
                </extend-form-item>
              </extend-form>

              <nz-form-item>
                <nz-form-control>
                  <div class="display-block">
                    <button style="padding: 1em 2.5em; height: unset" id="loginBtn" nz-button class="w-100" [nzType]="'primary'">ĐĂNG NHẬP</button>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </form>
          </nz-card>
        </div>
      </div>
    </div>
    <div class=" d-md-flex p-h-40 justify-content-between">
      <ul class="list-inline">
        <li class="list-inline-item">
          <a class="text-dark text-link" href="">Legal</a>
        </li>
        <li class="list-inline-item">
          <a class="text-dark text-link" href="">Privacy</a>
        </li>
      </ul>
    </div>
  </div>
</div>
